import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"


import ViewCalendar from "./ViewCalendar.js"




export default function Users() {

    return (
        <Routes>
            <Route path="/" element={<ViewCalendar />} />
        </Routes>
    )
}


